import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {CostRestService} from "../../../../api/services/cost.rest.service";
import {CostViewModel} from "./cost.view-model";
import {CostApiModel} from "../../../../api/models/cost.api.model";

@Injectable()
export class CostDataProviderService {
  constructor(
    private readonly costRS: CostRestService
  ) {
  }

  public postCost(costVM: CostViewModel): Observable<CostViewModel> {
    return this.costRS.create(CostApiModel.fromCostVM(costVM)).pipe(
      map((costAM: CostApiModel) => CostApiModel.toCostVM(costAM))
    );
  }

  public putCost(costVM: CostViewModel): Observable<CostViewModel> {
    return this.costRS.put(CostApiModel.fromCostVM(costVM)).pipe(
      map((costAM: CostApiModel) => CostApiModel.toCostVM(costAM))
    );
  }
}
